export const CheckSubAdmin = (subAdmin) => {
    if(subAdmin && subAdmin?.length !== 0) {
        let ArrSubAdmin = []
        subAdmin?.map((item) => {
            if (Number(item?.status) === 1) {
               switch (item?.type_sub_admin) {
                    case 0:
                        // console.log("Get All")
                        ArrSubAdmin?.push(0)
                        break;
                    case 1:
                        // console.log("ระบบลาออนไลน์")
                        ArrSubAdmin?.push(1)
                        break;
                    case 2:
                        // console.log("ระบบลงเวลาปฏิบัติงานแบบยืดหยุ่น")                    
                        ArrSubAdmin?.push(2)
                        break;
                    case 3:
                        // console.log("ระบบการประเมินผล การปฏิบัติราชการแบบออนไลน์")
                        ArrSubAdmin?.push(3)
                        break;
                    case 4:
                        // console.log("ระบบทรัพยากรออนไลน์")
                        ArrSubAdmin?.push(4)
                        break;
                    case 5:
                        // console.log("ระบบจัดการข้อมูล")
                        ArrSubAdmin?.push(5)
                        break;
                    case 6:
                        // console.log("ระบบจัดการไฟล์เงินเดือน")
                        ArrSubAdmin?.push(6)
                        break;
                } 
            }
        })
        if (ArrSubAdmin.length > 0) {
            return ArrSubAdmin
        } else {
            return false
        }
    } else {
        return false
    }
}